export enum TransactionErrorTypes {
  NONE = 'none',
  FAILED = 'failed',
  AUTHORIZED = 'authorized',
  PAYMENT_INIT = 'payment_init',
  COMPONENT_INIT = '3200',
  CANCELLED = 'canceled',
}
